import React from "react";
import "./achievementhero.css";

function AchievementHero() {
  return (
    <div className="achievementhero flex items-center justify-center px-2">
      <div className="container flex flex-col items-center justify-center">
        <p className="text-yellow-500">
          <i class="fa-solid fa-trophy fa-3x"></i>
        </p>
        <p className="text-white  font-bold text-3xl text-center">
          We are humbled to serve you and achieve your health goals
        </p>
        <p className="text-white  text-center mt-3 ">
          From heart | brain | kidney transplant | liver transparant | safe baby
          delivery| eye surgery and much more we have achieved in giving it to
          the community Safe surgical Operations and maternity deliverly
        </p>
      </div>
    </div>
  );
}

export default AchievementHero;
